package component

import com.github.quillraven.fleks.*
import com.soywiz.kds.*
import models.*

class NetworkInputDataComponent(
    val id: Int
) : Component<NetworkInputDataComponent> {
    var inputData: List<Packet> = emptyList()

    var physicData: Queue<PhysicState> = Queue()
    var canReadPhysicState = false
    override fun type() = NetworkInputDataComponent

    companion object : ComponentType<NetworkInputDataComponent>()
}
